module.exports = __webpack_public_path__ + "static/moonamar-champu-con-aceite-de-argan-y-comino-negro-bd6e94b086dccc77b479b903a0f30d68.png";